/* ============================================================
   Velvet Rituals — Velvet Vibes App Page · shared behaviour
   assets/vr-app.js

   Loaded (deferred) by every vr-app-* section. Each widget is
   feature-detected from the DOM, so behaviour activates only for
   the sections actually present on the page. The init guard makes
   it safe even when the script tag is included by multiple sections.
   ============================================================ */
(function () {
  'use strict';

  if (window.__vrAppInit) return;   // guard: run once even if loaded by many sections
  window.__vrAppInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var $$ = function (sel, ctx) {
      return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
    };

    function stickyHeaderOffset() {
      var val = getComputedStyle(document.documentElement).getPropertyValue('--sticky-offset').trim();
      return parseFloat(val) || 0;
    }

    function navHeight() {
      var nav = document.querySelector('.vr__nav');
      return (nav && nav.offsetHeight) || 60;
    }

    function smoothScrollTo(target) {
      var offset = stickyHeaderOffset() + navHeight();
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    /* ── Sticky nav: hide when user scrolls past Games section ── */
    (function () {
      var navSection = document.querySelector('.shopify-section--vr-app-nav');
      var gamesSection = document.querySelector('[data-pillar="games"]');
      if (!navSection || !gamesSection) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          /* isPast: games section has fully scrolled above the viewport */
          var isPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          navSection.classList.toggle('is-hidden', isPast);
        });
      }, { threshold: 0 });

      io.observe(gamesSection);
    }());

    /* ── Sticky nav: scroll-spy across pillar sections ── */
    (function () {
      var tabs = $$('.vr__nav-tab[data-target]');
      var sections = $$('[data-pillar]');
      if (!sections.length) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          tabs.forEach(function (tab) {
            tab.classList.toggle('is-active', tab.dataset.target === id);
          });
        });
      }, { rootMargin: '-35% 0px -55% 0px', threshold: 0 });

      sections.forEach(function (s) { io.observe(s); });
    }());

    /* ── Smooth scroll: nav tabs + hero pills ── */
    $$('.vr__nav-tab, .vr__hero-pill').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        e.preventDefault();
        smoothScrollTo(target);
      });
    });

    /* ── Play: feature tabs ── */
    $$('.vr__features').forEach(function (root) {
      var tabBtns = $$('.vr__feat-tab', root);
      var panels = $$('.vr__feat-panel', root);
      if (!tabBtns.length) return;

      tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.dataset.tab, 10);
          tabBtns.forEach(function (b, i) {
            b.classList.toggle('is-active', i === idx);
            b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          });
          panels.forEach(function (p, i) {
            p.classList.toggle('is-active', i === idx);
            if (i === idx) {
              var vid = p.querySelector('video');
              if (vid) { vid.currentTime = 0; vid.play().catch(function () {}); }
            }
          });
        });
      });
    });

    /* ── Stories: story card → player switcher ── */
    (function () {
      var cards = $$('.vr__story-card');
      if (!cards.length) return;

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          /* active state */
          cards.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
          card.classList.add('is-active');
          card.setAttribute('aria-pressed', 'true');

          var player = document.querySelector('.vr__player-mock');
          if (!player) return;

          /* update text */
          var titleEl = player.querySelector('.vr__player-title');
          var subEl   = player.querySelector('.vr__player-sub');
          if (titleEl) titleEl.textContent = card.dataset.title || '';
          if (subEl) {
            var sub = card.dataset.subtitle || '';
            var dur = card.dataset.duration || '';
            subEl.textContent = sub && dur ? sub + ' · ' + dur : sub || dur;
          }

          /* update tags */
          var tagsEl = player.querySelector('.vr__player-tags');
          if (tagsEl) {
            var rawTags = card.dataset.tags || '';
            var tags = rawTags.split(',').map(function (t) { return t.trim(); }).filter(Boolean);
            tagsEl.innerHTML = tags.map(function (t) {
              return '<span class="vr__story-tag">' + t.replace(/</g, '&lt;') + '</span>';
            }).join('');
          }

          /* update cover image */
          var coverEl  = player.querySelector('.vr__player-cover');
          var coverImg = player.querySelector('.vr__player-cover-img');
          if (coverImg) {
            if (card.dataset.cover) {
              coverImg.src   = card.dataset.cover;
              coverImg.style.display = '';
              if (coverEl) coverEl.classList.remove('vr__player-cover--empty');
            } else {
              coverImg.src   = '';
              coverImg.style.display = 'none';
              if (coverEl) coverEl.classList.add('vr__player-cover--empty');
            }
          }

          /* update audio src and reset player */
          var audioEl = player.querySelector('audio');
          if (audioEl) {
            audioEl.pause();
            audioEl.src = card.dataset.audio || '';
            if (audioEl.src) { audioEl.load(); } else { audioEl.removeAttribute('src'); }
          }

          var playBtn = player.querySelector('.vr__player-play');
          if (playBtn) { playBtn.dataset.playing = 'false'; playBtn.textContent = '▶'; playBtn.setAttribute('aria-label', 'Play story'); }

          var progEl = player.querySelector('.vr__player-progress');
          var barEl  = player.querySelector('.vr__player-bar');
          var timeEl = player.querySelector('.vr__player-time');
          if (progEl) progEl.style.width = '0%';
          if (barEl)  barEl.setAttribute('aria-valuenow', 0);
          if (timeEl) timeEl.textContent = '';
        });
      });
    }());

    /* ── Stories: audio player ── */
    $$('.vr__player-mock').forEach(function (player) {
      var audio = player.querySelector('audio');
      var playBtn = player.querySelector('.vr__player-play');
      var rewBtn = player.querySelector('[data-skip="rew"]');
      var fwdBtn = player.querySelector('[data-skip="fwd"]');
      var progEl = player.querySelector('.vr__player-progress');
      var barEl = player.querySelector('.vr__player-bar');
      var timeEl = player.querySelector('.vr__player-time');
      if (!playBtn) return;

      function fmt(sec) {
        if (!isFinite(sec)) return '';
        var m = Math.floor(sec / 60);
        var s = Math.floor(sec % 60).toString();
        if (s.length < 2) s = '0' + s;
        return m + ':' + s;
      }

      function setPlaying(state) {
        playBtn.dataset.playing = state ? 'true' : 'false';
        playBtn.textContent = state ? '⏸' : '▶';
        playBtn.setAttribute('aria-label', state ? 'Pause story' : 'Play story');
      }

      /* No real audio attached → animate the mock progress bar */
      if (!audio) {
        var mockPos = 0.38;
        var mockPlay = false;
        playBtn.addEventListener('click', function () {
          mockPlay = !mockPlay;
          setPlaying(mockPlay);
          if (mockPlay) {
            (function tick() {
              if (!mockPlay) return;
              mockPos = Math.min(mockPos + 0.001, 0.97);
              if (progEl) progEl.style.width = (mockPos * 100) + '%';
              if (barEl) barEl.setAttribute('aria-valuenow', Math.round(mockPos * 100));
              requestAnimationFrame(tick);
            }());
          }
        });
        if (rewBtn) rewBtn.addEventListener('click', function () { mockPos = Math.max(0, mockPos - 0.1); if (progEl) progEl.style.width = (mockPos * 100) + '%'; });
        if (fwdBtn) fwdBtn.addEventListener('click', function () { mockPos = Math.min(1, mockPos + 0.1); if (progEl) progEl.style.width = (mockPos * 100) + '%'; });
        if (progEl) progEl.style.animation = 'none';
        return;
      }

      /* Real audio controls */
      audio.hidden = true;

      playBtn.addEventListener('click', function () {
        if (audio.paused) { audio.play().catch(function () {}); setPlaying(true); }
        else { audio.pause(); setPlaying(false); }
      });
      if (rewBtn) rewBtn.addEventListener('click', function () { audio.currentTime = Math.max(0, audio.currentTime - 10); });
      if (fwdBtn) fwdBtn.addEventListener('click', function () { audio.currentTime = Math.min(audio.duration || 0, audio.currentTime + 10); });

      audio.addEventListener('timeupdate', function () {
        if (!audio.duration) return;
        var pct = audio.currentTime / audio.duration;
        if (progEl) progEl.style.width = (pct * 100) + '%';
        if (barEl) barEl.setAttribute('aria-valuenow', Math.round(pct * 100));
        if (timeEl) timeEl.textContent = fmt(audio.currentTime) + ' / ' + fmt(audio.duration);
      });
      audio.addEventListener('ended', function () { setPlaying(false); });
      audio.addEventListener('pause', function () { setPlaying(false); });
      audio.addEventListener('play', function () { setPlaying(true); });

      if (barEl) {
        barEl.addEventListener('click', function (e) {
          if (!audio.duration) return;
          var rect = barEl.getBoundingClientRect();
          audio.currentTime = ((e.clientX - rect.left) / rect.width) * audio.duration;
        });
        barEl.style.cursor = 'pointer';
      }
      if (progEl) progEl.style.animation = 'none';
    });

    /* ── Games: interactive branching demo ── */
    $$('.vr__demo').forEach(function (demo) {
      var sceneEl = demo.querySelector('.vr__demo-scene');
      var choicesEl = demo.querySelector('.vr__demo-choices');
      var endEl = demo.querySelector('.vr__demo-end');
      var restartEl = demo.querySelector('.vr__demo-restart');
      if (!sceneEl || !choicesEl) return;

      var TREE = {
        start: {
          scene: 'The hotel room is warm. He leaves a key on the table and a note that says he\'ll be back by midnight.',
          choices: [
            { label: 'Wait for him', next: 'wait' },
            { label: 'Leave before he returns', next: 'leave' }
          ]
        },
        wait: {
          scene: 'You stay. The room fills with quiet. Then — the door opens. He looks at you like the night was always leading here.',
          choices: [
            { label: 'Let him speak first', next: 'end_a' },
            { label: 'Say what you\'ve been holding back', next: 'end_b' }
          ]
        },
        leave: {
          scene: 'You\'re already in the elevator when your phone lights up. His name on the screen.',
          choices: [
            { label: 'Open the message', next: 'end_c' },
            { label: 'Keep walking', next: 'end_d' }
          ]
        },
        end_a: { scene: 'He doesn\'t say anything. Neither do you. Some moments don\'t need words.', end: true },
        end_b: { scene: 'The words come out before you can stop them. He listens. Really listens. Everything shifts.', end: true },
        end_c: { scene: 'Three words. You read them twice. The elevator doors open and you turn around.', end: true },
        end_d: { scene: 'Not every story is about someone else. This one was always about you.', end: true }
      };

      function render(nodeKey) {
        var node = TREE[nodeKey];
        if (!node) return;

        sceneEl.style.opacity = '0';
        choicesEl.style.opacity = '0';

        setTimeout(function () {
          sceneEl.textContent = node.scene;
          choicesEl.innerHTML = '';
          if (!node.end) {
            node.choices.forEach(function (choice) {
              var btn = document.createElement('button');
              btn.className = 'vr__demo-choice';
              btn.textContent = choice.label;
              btn.addEventListener('click', function () { render(choice.next); });
              choicesEl.appendChild(btn);
            });
          }
          sceneEl.style.transition = 'opacity 0.35s ease';
          choicesEl.style.transition = 'opacity 0.35s ease 0.1s';
          sceneEl.style.opacity = '1';
          choicesEl.style.opacity = '1';

          if (node.end) {
            setTimeout(function () { if (endEl) endEl.hidden = false; }, 600);
          } else if (endEl) {
            endEl.hidden = true;
          }
        }, 200);
      }

      render('start');
      if (restartEl) {
        restartEl.addEventListener('click', function () {
          if (endEl) endEl.hidden = true;
          render('start');
        });
      }
    });

    /* ── Games: device-aware download button ── */
    /* The button carries data-ios-url / data-android-url; JS picks the right one.
       Falls back to ios_url if platform is unknown or the other URL isn't set. */
    $$('.vr__demo-dl-btn').forEach(function (btn) {
      var ua         = navigator.userAgent;
      var isAndroid  = /Android/i.test(ua);
      var isIOS      = /iPad|iPhone|iPod/i.test(ua) && !window.MSStream;
      var iosUrl     = btn.dataset.iosUrl;
      var androidUrl = btn.dataset.androidUrl;

      if (isAndroid && androidUrl) {
        btn.setAttribute('href', androidUrl);
        btn.setAttribute('aria-label', 'Get it on Google Play');
      } else if (isIOS && iosUrl) {
        btn.setAttribute('href', iosUrl);
        btn.setAttribute('aria-label', 'Download on the App Store');
      }
      /* Desktop / unknown: keep the default href already set by Liquid */
    });

    /* ── Scroll-to-top button (revealed once past hero) ── */
    (function () {
      var btn = document.querySelector('.vr__totop');
      var hero = document.querySelector('.vr__hero');
      if (!btn || !hero) return;

      btn.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        btn.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(hero);

      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }());

    /* ── Scroll reveals — same motion language as the stories,
       affiliate, and AI partner pages. Section intros are tagged
       automatically so every vr-app section fades up on entry. ── */
    (function () {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      document.querySelectorAll('.vr-app .vr__section-intro').forEach(function (el) {
        el.classList.add('vr-r');
      });

      var els = document.querySelectorAll('.vr-app .vr-r');
      if (!els.length) return;

      if (!('IntersectionObserver' in window) || reduced) {
        els.forEach(function (el) { el.classList.add('in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -36px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }());
  });
}());
